import { Component, Inject, Injectable, OnInit, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Subscription } from 'rxjs';

import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";

import { LoginStateService } from '../_services/index';
import { LoginState } from '../_models/index';
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  loginBox: boolean = false;
  loggedIn: boolean = false;
  isAdmin: boolean = false;
  expanded: boolean = false;
  isMobile: boolean;
  current_year: number;
  private loginSubscription: Subscription;

  constructor(@Inject(DOCUMENT) private document: any, private http: HttpClient, private loginStateService: LoginStateService,  private router: Router
) {
    this.checkMobile();
  }

ngOnInit(): void {
  this.loginSubscription = this.loginStateService.isUserLoggedIn
    .subscribe((state) => {
      this.loggedIn = state.loggedIn;
      this.isAdmin = state.isAdmin;
      console.log('Header updated — isAdmin:', this.isAdmin, 'loggedIn:', this.loggedIn);

      this.loginBox = false;
      this.expanded = false;

      if (!state.loggedIn && this.router.url.startsWith('/internal')) {
        this.router.navigate(['/']);
      }
    });
}

  showLogin() {
    this.loginBox = !this.loginBox;
  }

  clickedInside($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  toggleNav() {
    this.expanded = !this.expanded;
    if (!this.expanded) {
      this.loginBox = false;
    }
  }

  collapseNav() {
    this.expanded = false;
  }

  checkMobile() {
    if (window.matchMedia('(max-width: 760px)').matches) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  @HostListener('window:resize') onResize() {
    this.checkMobile();
  }

  @HostListener('document:click', ['$event']) clickedOutside($event){
    if (this.loginBox)
      this.loginBox = false;
  }
}
